import styled from 'styled-components';

const BlockSubtitle = styled.div`
  border-bottom: 1px solid ${props => props.theme.color.borderPrimary};
  color: ${props => props.theme.color.calloutSecondary};
  font-family: ${props => props.theme.font.sourceSans};
  font-size: 12px;
  font-weight: ${props => props.theme.fontWeight.semibold};
  margin: ${p => p.topMargin ? '80px' : 0} 0 12px 0;
  padding-bottom: 10px;
  text-transform: uppercase;

  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    margin: ${p => p.topMargin ? '30px' : 0} 0 12px 0;
  }
`;

export default BlockSubtitle;
